import {selectIsFeatureEnabled} from 'state/feature/featureSelectors';
import {FEATURE_SWITCHES} from 'app/FeatureSwitches';
import {createSelector} from 'reselect';
import {STATUSES} from './environmentConstants';
import {DOMAIN_WHITELIST} from 'constants/DomoAppConstants';

export const getEnvironment = state => state.environment;

export const selectUserId = state => state.environment.user.id;

export const selectIsEnvironmentLoading = state =>
  state.environment.status === STATUSES.LOADING;

export const selectIsEnvironmentLoaded = state =>
  state.environment.status === STATUSES.LOADED;

export const selectIsCurrentUser = (state, id) =>
  state.environment.user.id === parseInt(id, 10);

export const selectAuthorizedDomains = createSelector(
  state => state.environment.authorizedDomains,
  authorizedDomains => authorizedDomains.sort()
);

export const selectRoleId = state => state.environment.user.roleId;

export const selectHasTrialStatus = state =>
  !!state.environment.user.trialStatus;

const EMPTY = {};
export const selectTrialStatus = state =>
  state.environment.user.trialStatus || EMPTY;

export const selectHasTrialAvailable = state =>
  selectIsFeatureEnabled(state, FEATURE_SWITCHES.SOCIAL_UPGRADE) &&
  !selectTrialStatus(state).hasTrialed;

export const selectHasSentUpgradeRequest = state =>
  state.environment.user.trialStatus &&
  state.environment.user.trialStatus.requested;

export const selectIsExternal = () => !!global.ENV.external;

export const selectIsEmbed = () => !!global.ENV.embed;

export const selectIsPublic = () => !!global.ENV.public;

export const selectIsDavinci = () => !!global.ENV.davinci;

export const selectIsFull = () => !!global.ENV.full;

export const selectPublicCardId = () => {
  const results = /cards\/([^/]+)/.exec(window.location.pathname);
  return results && results.length === 2 ? results[1] : null;
};

const PRIVATE_AUDIENCE = 'private';

export const selectIsDefaultHuddleVisibilityPrivate = state =>
  state.environment.buzzAudienceDefaultsObjectChat === PRIVATE_AUDIENCE;

export const selectAuthorizedAppDomains = state =>
  selectIsFeatureEnabled(state, FEATURE_SWITCHES.DOMOAPPS_DOMAIN_WHITELIST)
    ? state.environment.authorizedAppDomains
    : DOMAIN_WHITELIST;

export const selectHasAuthority = (state, authority) =>
  state.environment.authorities.includes(authority);
